import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export const useInfiniteQueryUserMemberSessionPackSubscriptionCurrent = ({
  api,
  userMemberId,
  enabled,
}: {
  api: ApiType;
  userMemberId: string;
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey:
      memberQueryKeys.userMemberSessionPackSubscriptionCurrent(userMemberId),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.memberApi.userMemberSessionPackSubscriptionCurrent({
          userMemberId,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
    initialPageParam: undefined,
  });
